import { render, staticRenderFns } from "./NewsEntryView.vue?vue&type=template&id=52e56422&"
import script from "./NewsEntryView.vue?vue&type=script&lang=js&"
export * from "./NewsEntryView.vue?vue&type=script&lang=js&"
import style0 from "./NewsEntryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports